export default __webpack_public_path__ + "static/media/failed-facial.f89f3835.svg";